export default __webpack_public_path__ + "static/inkspill-s-4868d783beeff1a42a23c7c7cd5d4b94.mp4";